import { InvoiceSorting } from "./invoiceSorting";
import { ErpInvoiceState } from "./erpInvoiceState";

export class InvoiceSearchRequestDto {
	public invoiceIds: number[] = [];
	public dateFrom?: Date;
	public dateTo?: Date;
	public searchTerm: string = "";
	public states: Array<ErpInvoiceState> = new Array<ErpInvoiceState>();
	public sortingType: InvoiceSorting = InvoiceSorting.CreatedAtDescending;
	public dueUntil: Date = new Date();
	public regions: string[] = ["Schweiz/Liechtenstein", "Deutschland", "Österreich"];
	public onlyShowGemahnt: boolean = false;
	public onlyShowPrepay: boolean = false;
	public customerNumber: string = "";
}
